import timezones from "@/assets/timezones.json";

export const languagesOptions = [
  {
    value: "en-US",
    text: "English (United States)",
    icon: require("@/assets/images/flags/en.png"),
  },
  {
    value: "it-IT",
    text: "Italiano (Italia)",
    icon: require("@/assets/images/flags/it.png"),
  },
  {
    value: "fr-FR",
    text: "Fran\u00E7ais (France)",
    icon: require("@/assets/images/flags/fr.png"),
  },
  {
    value: "es-ES",
    text: "Espa\u00F1ol (Espa\u00F1a)",
    icon: require("@/assets/images/flags/es.png"),
  },
  {
    value: "de-DE",
    text: "Deutsch (Deutschland)",
    icon: require("@/assets/images/flags/de.png"),
  },
  {
    value: "pl-PL",
    text: "Polski (Polska)",
    icon: require("@/assets/images/flags/pl.png"),
  },
  {
    value: "ru-RU",
    text: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439 (\u0420\u043E\u0441\u0441\u0438\u044F)",
    icon: require("@/assets/images/flags/ru.png"),
  },
  {
    value: "pt-PT",
    text: "Portugu\u00EAs (Portugal)",
    icon: require("@/assets/images/flags/pt.png"),
  },
  {
    value: "ja-JP",
    text: "\u65E5\u672C\u8A9E (\u65E5\u672C)",
    icon: require("@/assets/images/flags/ja.png"),
  },
  {
    value: "zh-Hant",
    text: "\u4E2D\u6587\uFF08\u4E2D\u56FD\uFF09",
    icon: require("@/assets/images/flags/zh.png"),
  },
];

export const timezonesOptions = timezones;
